// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inventoryFullContainer {
    background-color: #242b36;
    border: 1px solid #2e3e4e;
    border-radius: 8px;
    padding: 4px;
}

.inventoryContainer {
    padding: 4px;
    border-radius: 4px;
    border: 1px solid #71deff;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
}

.inventoryWrapper {
    position: relative;
    width: 540px;
    height: 340px;
    overflow-y: auto;
    overflow-x: hidden;
}

.inventoryCategoryContainer {
    background-color: #2f404d;
    border-radius: 3px;
    width: 100%;
    padding: 4px 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
}

.inventoryCategories {
    display: flex;
    gap: 8px;
}

.inventoryCategory {
    border-radius: 3px;
    border: 1px solid #71deff;
    background-color: #1c1f25;
    padding: 4px;
    font-size: 10px;
    font-weight: 400;
    font-family: 'Kim';
    color: #ffffff;
    letter-spacing: 0.4px;
}

.inventoryCategory:hover {
    background-color: transparent;
    border: 1px solid #a5670f;
    cursor: pointer;
}

.inventoryLabel {
    font-size: 12px;
    font-weight: 500;
    font-family: 'Kim';
    letter-spacing: 0.6px;
}

.categoryCount {
    background-color: #1c1f25;
    padding: 4px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 600;
    color: #ffffff;
    display: flex;
    align-items: center;
}

.categoryCount span {
    color: #71deff;
}

.categoryBtn {
    width: 24px;
    height: 24px;
    background-size: 100% 100%;
}

.categoryBtn:hover {
    opacity: 0.6;
    cursor: pointer;
}

.hint-modal-container {
    box-sizing: border-box;
    background-color: #1c1f25;
    border: 1px solid #71deff;
    border-radius: 8px;
    width: 264px;
    height: 180px;
    padding: 12px;
    position: relative;
}

.hint-modal-heading {
    font-size: 24px;
    text-align: center;
    color: #71deff;
}

.hint-modal-button-container {
    position: absolute;
    bottom: 12px;
    right: 12px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}

.hint-modal-button-container button {
    padding: 10px;
    font-size: 14px;
    color: #ffffff;
    border-radius: 6px;
    border: 1px solid #46899e;
    background-color: transparent;
}

.hint-modal-button-container button:hover {
    opacity: 0.7;
    cursor: pointer;
    border: 1px solid #8be0f9;
}

.empty-slots-container {
    background-color: rgba(28, 31, 37, 0.85);
    border-radius: 8px;
    padding: 12px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 12px;
}

.empty-slots-container p {
    font-size: 16px;
    text-align: center;
}

.empty-slots-container a {
    padding: 8px;
    font-size: 14px;
    color: #ffffff;
    border-radius: 6px;
    border: 1px solid #46899e;
    background-color: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    text-decoration: none;
}

.empty-slots-container a img {
    width: 20px;
    height: 20px;
}

.inventory-sections {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 8px;
    height: 100%;
}

.inventory-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.section-title {
    color: #ffffff;
    font-size: 12px;
    font-weight: 500;
    font-family: 'Kim';
    letter-spacing: 0.6px;
    background-color: #2f404d;
    padding: 4px 8px;
    border-radius: 3px;
    display: inline-block;
    margin: 0;
    border: 1px solid #71deff;
}

.section-items {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    max-width: 520px;
}

.inventoryWrapper::-webkit-scrollbar {
    width: 8px;
}

.inventoryWrapper::-webkit-scrollbar-track {
    background: #1c1f25;
    border-radius: 4px;
}

.inventoryWrapper::-webkit-scrollbar-thumb {
    background: #2e3e4e;
    border-radius: 4px;
}

.inventoryWrapper::-webkit-scrollbar-thumb:hover {
    background: #3e4e5e;
}`, "",{"version":3,"sources":["webpack://./src/components/inventory/Inventory.style.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".inventoryFullContainer {\n    background-color: #242b36;\n    border: 1px solid #2e3e4e;\n    border-radius: 8px;\n    padding: 4px;\n}\n\n.inventoryContainer {\n    padding: 4px;\n    border-radius: 4px;\n    border: 1px solid #71deff;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n}\n\n.inventoryWrapper {\n    position: relative;\n    width: 540px;\n    height: 340px;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.inventoryCategoryContainer {\n    background-color: #2f404d;\n    border-radius: 3px;\n    width: 100%;\n    padding: 4px 6px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-sizing: border-box;\n}\n\n.inventoryCategories {\n    display: flex;\n    gap: 8px;\n}\n\n.inventoryCategory {\n    border-radius: 3px;\n    border: 1px solid #71deff;\n    background-color: #1c1f25;\n    padding: 4px;\n    font-size: 10px;\n    font-weight: 400;\n    font-family: 'Kim';\n    color: #ffffff;\n    letter-spacing: 0.4px;\n}\n\n.inventoryCategory:hover {\n    background-color: transparent;\n    border: 1px solid #a5670f;\n    cursor: pointer;\n}\n\n.inventoryLabel {\n    font-size: 12px;\n    font-weight: 500;\n    font-family: 'Kim';\n    letter-spacing: 0.6px;\n}\n\n.categoryCount {\n    background-color: #1c1f25;\n    padding: 4px;\n    border-radius: 3px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n}\n\n.categoryCount span {\n    color: #71deff;\n}\n\n.categoryBtn {\n    width: 24px;\n    height: 24px;\n    background-size: 100% 100%;\n}\n\n.categoryBtn:hover {\n    opacity: 0.6;\n    cursor: pointer;\n}\n\n.hint-modal-container {\n    box-sizing: border-box;\n    background-color: #1c1f25;\n    border: 1px solid #71deff;\n    border-radius: 8px;\n    width: 264px;\n    height: 180px;\n    padding: 12px;\n    position: relative;\n}\n\n.hint-modal-heading {\n    font-size: 24px;\n    text-align: center;\n    color: #71deff;\n}\n\n.hint-modal-button-container {\n    position: absolute;\n    bottom: 12px;\n    right: 12px;\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n}\n\n.hint-modal-button-container button {\n    padding: 10px;\n    font-size: 14px;\n    color: #ffffff;\n    border-radius: 6px;\n    border: 1px solid #46899e;\n    background-color: transparent;\n}\n\n.hint-modal-button-container button:hover {\n    opacity: 0.7;\n    cursor: pointer;\n    border: 1px solid #8be0f9;\n}\n\n.empty-slots-container {\n    background-color: rgba(28, 31, 37, 0.85);\n    border-radius: 8px;\n    padding: 12px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 12px;\n}\n\n.empty-slots-container p {\n    font-size: 16px;\n    text-align: center;\n}\n\n.empty-slots-container a {\n    padding: 8px;\n    font-size: 14px;\n    color: #ffffff;\n    border-radius: 6px;\n    border: 1px solid #46899e;\n    background-color: transparent;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    text-decoration: none;\n}\n\n.empty-slots-container a img {\n    width: 20px;\n    height: 20px;\n}\n\n.inventory-sections {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding: 8px;\n    height: 100%;\n}\n\n.inventory-section {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.section-title {\n    color: #ffffff;\n    font-size: 12px;\n    font-weight: 500;\n    font-family: 'Kim';\n    letter-spacing: 0.6px;\n    background-color: #2f404d;\n    padding: 4px 8px;\n    border-radius: 3px;\n    display: inline-block;\n    margin: 0;\n    border: 1px solid #71deff;\n}\n\n.section-items {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    max-width: 520px;\n}\n\n.inventoryWrapper::-webkit-scrollbar {\n    width: 8px;\n}\n\n.inventoryWrapper::-webkit-scrollbar-track {\n    background: #1c1f25;\n    border-radius: 4px;\n}\n\n.inventoryWrapper::-webkit-scrollbar-thumb {\n    background: #2e3e4e;\n    border-radius: 4px;\n}\n\n.inventoryWrapper::-webkit-scrollbar-thumb:hover {\n    background: #3e4e5e;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
